/**
 * Mô tả từng trang của web admin cho khung "Trang này dùng để làm gì" (components/admin/PageGuide.js).
 * Mỗi trang: intro là một câu tóm tắt, items là [tên chức năng, tác dụng], note là lưu ý (không bắt buộc).
 */
const PAGE_GUIDES = {
  dashboard: {
    intro: "Mở đầu ca: xem game có đang chạy ổn, có đông không, và điều khiển máy chủ khi cần.",
    items: [
      [
        "Ô số liệu",
        "Số người đang online (so với giờ này hôm qua), cao nhất hôm nay và lúc mấy giờ, máy chủ đang chạy hay sắp bảo trì, giờ vàng.",
      ],
      [
        "Sơ đồ người chơi online",
        "24 giờ: đường xanh là hôm nay, đường cam nét đứt là hôm qua — xanh cao hơn cam là hôm nay đông hơn. 7 / 30 ngày: mỗi cột là số người cao nhất trong ngày. Rê chuột để xem số; bấm Xem dạng bảng để xem số liệu.",
      ],
      [
        "Bảo trì",
        "Báo đếm ngược cho người chơi rồi đá mọi người ra; chọn tự bật lại (bảo trì nhanh) hoặc tắt hẳn. Đang đếm ngược thì có nút Huỷ bảo trì ở đầu trang.",
      ],
      ["Khởi động lại ngay", "Ngắt mọi người ngay không báo trước — nên dùng Bảo trì thay thế."],
      ["Người chơi đang ở đâu", "Map nào đang có bao nhiêu người, theo từng khu."],
      [
        "Nâng cao (cuối trang, gập sẵn)",
        "Đọc lại tỉ lệ exp / ngọc, dọn bộ nhớ, tắt hẳn máy chủ (phải gõ xác nhận) — chỉ dùng khi kỹ thuật yêu cầu.",
      ],
    ],
    note: "Đầu trang hiện cảnh báo màu khi mất kết nối máy chủ, đang bảo trì hoặc có tiến trình nền bị dừng.",
  },
  players: {
    intro: "Tìm tài khoản / nhân vật và mở trang chi tiết để xử lý.",
    items: [
      [
        "Tìm kiếm",
        "Theo tên nhân vật, tên tài khoản hoặc user ID; có thể lọc chỉ người đang online.",
      ],
      ["Bấm vào một dòng", "Mở trang chi tiết người chơi với đầy đủ thao tác."],
      [
        "Tạo tài khoản (chỉ chủ)",
        "Tạo tài khoản game mới, có thể tạo luôn nhân vật và cấp quyền web admin. Mật khẩu chỉ hiện một lần.",
      ],
      ["Đặt mật khẩu mới", "Đổi mật khẩu đăng nhập của tài khoản người chơi."],
    ],
  },
  "players-detail": {
    intro:
      "Mọi thông tin về một người chơi và các việc làm được với họ. Đầu trang là trạng thái và số tiền; nút thao tác chia 3 nhóm.",
    items: [
      [
        "Tặng & cộng",
        "Cộng / trừ vàng, ngọc, lúa, năng lượng; cộng / trừ Pet Coin (tiền nạp, phải ghi lý do); tặng vật phẩm, pet (gửi vào hòm thư, người chơi tự bấm nhận); gửi thư.",
      ],
      [
        "Liên lạc",
        "Nhắn tin hiện lên màn hình, dịch chuyển người chơi bị kẹt. Chỉ dùng được khi người chơi đang trong game.",
      ],
      [
        "Xử lý vi phạm",
        "Đá khỏi game (vẫn vào lại được), khoá chat có thời hạn, khoá tài khoản có thời hạn hoặc vĩnh viễn — luôn ghi lý do.",
      ],
      [
        "Nút bị mờ",
        "Dòng chữ nhỏ ngay dưới nhóm nút sẽ nói vì sao (ví dụ người chơi đang không trong game).",
      ],
      [
        "Người chơi đang trong game",
        "Ở các tab chỉ thu hồi được. Sửa vật phẩm, sửa pet, cấp danh hiệu, buff trang bị phải chờ người chơi thoát game.",
      ],
      [
        "Các tab",
        "Hành trang (đồ từng túi), Pet, Danh hiệu, Sổ Pet Coin, VIP, Hòm thư, Đánh boss, Lịch sử. Có thể gửi link trang để người khác mở đúng tab.",
      ],
      [
        "Nâng cao (cuối tab Tổng quan, gập sẵn)",
        "Đặt mật khẩu mới, cho nhận lại quà gộp server, cấp / gỡ quyền admin (chỉ chủ web), xoá nhân vật hoặc tài khoản (có sao lưu trước khi xoá).",
      ],
    ],
    note: "Mọi thao tác đều được ghi vào tab Lịch sử của người chơi kèm tên admin web.",
  },
  mail: {
    intro:
      "Gửi thư (có thể kèm quà) vào hòm thư trong game. Làm lần lượt 4 bước, xem khung Kiểm tra lại rồi bấm gửi.",
    items: [
      [
        "1. Gửi cho ai",
        "Một vài người: bấm Chọn người nhận, tìm theo tên nhân vật hoặc tên tài khoản. Toàn server: mọi nhân vật, có thể cho cả người tạo nhân vật sau khi gửi.",
      ],
      ["2. Nội dung thư", "Tiêu đề bắt buộc, lời nhắn không bắt buộc."],
      [
        "3. Quà kèm theo",
        "Bật Có kèm quà rồi bấm Thêm quà: chọn loại bên trái, bấm các món (hoặc nhập số vàng, ngọc...) cho vào giỏ; bấm Thêm là xong. Người chơi tự bấm nhận trong hòm thư.",
      ],
      ["4. Hạn thư", "Thư tự biến mất sau số ngày chọn; quà chưa nhận cũng mất theo."],
      [
        "Gửi toàn server",
        'Hộp xác nhận ghi rõ số nhân vật và quà, phải gõ "gửi toàn server" mới gửi được.',
      ],
      [
        "Thư toàn server đang hiệu lực",
        "Thu hồi để người chưa nhận không thấy thư nữa; ai đã nhận quà thì vẫn giữ.",
      ],
      [
        "Công cụ test (gập ở cuối trang)",
        "Tặng toàn bộ vật phẩm và pet để thử game — chỉ dùng trên máy chủ test; Thu hồi thư test để rút lại.",
      ],
    ],
    note: "Mọi lần gửi đều ghi vào Lịch sử kèm tên admin web.",
  },
  tasks: {
    intro: "Sửa nhiệm vụ trong game và gỡ kẹt nhiệm vụ cho người chơi.",
    items: [
      [
        "Danh sách nhiệm vụ",
        "Tìm theo tên, loại, NPC. Đỏ = nhận là xong ngay, cam = xong không được quà. Bấm Sửa để đổi yêu cầu, quà, mô tả — người đang làm dở vẫn theo bản cũ.",
      ],
      [
        "Tra người chơi",
        "Gõ tên nhân vật để xem họ đang làm gì, đã xong gì. Người chơi kẹt: Chỉnh tiến độ → Đặt đủ, rồi họ tự trả ở NPC để nhận quà.",
      ],
      [
        "Đánh dấu xong",
        "Chuyển nhiệm vụ sang đã xong nhưng KHÔNG trả quà — muốn bù quà thì gửi qua Thư & quà.",
      ],
      [
        "Giao / Bỏ / Cho làm lại",
        "Giao bỏ qua điều kiện mở. Bỏ thì mất tiến độ. Bấm x ở mục Đã xong để người chơi làm lại (quà cũ không bị thu).",
      ],
    ],
  },
  boss: {
    intro: "Theo dõi và điều khiển boss.",
    items: [
      ["Đang diễn ra", "Bộ đếm quái của từng khu, boss nào đang sống, còn bao nhiêu máu."],
      [
        "Đặt bộ đếm / Gọi ngay",
        "Chỉnh số quái còn thiếu để boss ra, hoặc gọi boss của khu đó ra luôn.",
      ],
      ["Nhật ký", "Các trận boss đã kết thúc: ai tham gia, ai kết liễu, ai trúng bốc thăm."],
      [
        "Giờ vàng",
        "Các khung giờ nhân exp, ngọc, rơi đồ và bộ đếm boss, chọn được ngày trong tuần. Khung chồng giờ thì hệ số nhân dồn. Không có khung nào bật thì dùng giờ vàng dự phòng (chỉ nhân bộ đếm boss).",
      ],
      [
        "Danh sách boss: Sửa",
        "Đổi tên, hình dạng, chỉ số, quà của boss. Boss ra sau mới dùng số mới.",
      ],
      [
        "Danh sách boss: Gọi ra",
        "Đưa một boss bất kỳ ra map/khu tuỳ chọn trong số phút đặt trước, không ảnh hưởng bộ đếm.",
      ],
    ],
  },
  clans: {
    intro:
      "Xem và chỉnh bang hội. Bấm vào một bang để mở chi tiết (link có thể gửi cho người khác).",
    items: [
      [
        "Danh sách",
        "Tìm bang theo tên bang hoặc tên bang chủ; sắp xếp theo cấp, quỹ, số thành viên.",
      ],
      [
        "Chi tiết bang",
        "Tài nguyên, công trình, boss bang đang đánh, thành viên và cống hiến, nhật ký, đơn xin vào.",
      ],
      [
        "Sửa bang",
        "Đổi tên, khẩu hiệu, cấp, quỹ, kinh nghiệm, linh thạch, hồn binh. Áp dụng ngay và ghi vào nhật ký bang.",
      ],
      ["Làm bang chủ", "Chuyển chức bang chủ; bang chủ cũ thành thành viên thường."],
      ["Đổi chức", "Phó bang, trưởng lão hoặc thành viên (số chức vụ tối đa theo cấp bang)."],
      [
        "Đuổi",
        "Đưa thành viên ra khỏi bang: mất cống hiến trong bang, chờ 24 giờ mới vào bang lại.",
      ],
    ],
  },
  market: {
    intro: "Xem đồ người chơi đang treo bán ở chợ (ki ốt) và gỡ món có vấn đề.",
    items: [
      ["Lọc", "Theo loại ki ốt, tên món, người được chỉ định mua, hoặc tra tên một người bán."],
      [
        "Gỡ",
        "Lấy món đồ khỏi ki ốt và trả về hành trang người bán (offline thì trả ở lần đăng nhập tới), kèm số ngọc đã bán lẻ được. Người bán nhận thư kèm lý do — nên luôn ghi lý do.",
      ],
    ],
  },
  payment: {
    intro:
      "Nạp tiền qua chuyển khoản ngân hàng (mã QR): người chơi tạo đơn trên website, tiền về thì Pet Coin tự gửi vào hòm thư trong game.",
    items: [
      [
        "Khách báo đã chuyển mà chưa nhận",
        "Tab Đơn nạp: tìm theo tên tài khoản. Đơn Thành công là đã gửi thư Pet Coin — nhắc khách mở hòm thư. Không thấy: sang Giao dịch ngân hàng, lọc Không khớp đơn, tìm khoản đúng số tiền / giờ chuyển rồi bấm Gán.",
      ],
      [
        "Cảnh báo đỏ đầu trang",
        "Có tiền thật đã vào nhưng chưa khớp đơn (thường do khách chuyển sai / thiếu nội dung). Bấm Xử lý ngay để mở đúng danh sách.",
      ],
      [
        "Gán",
        "Gửi Pet Coin cho đúng người theo mã đơn hoặc tên tài khoản, bắt buộc ghi lý do. Không thu hồi được — kiểm tra biên lai trước.",
      ],
      [
        "Bỏ qua",
        "Khoản tiền không phải nạp game (chuyển thử, chuyển nhầm đã hoàn tiền), ghi lý do.",
      ],
      [
        "Cấu hình",
        "Bật / tắt kênh nạp (có hiệu lực ngay), sửa tài khoản nhận tiền, mức tối thiểu, thời gian giữ mã QR. Cần quyền sửa cấu hình nạp.",
      ],
      [
        "Đối soát",
        "Tổng tiền thật theo ngày. So cột Tiền vào với sao kê ngân hàng: sao kê nhiều hơn là có khoản ngân hàng không báo về, cần báo kỹ thuật.",
      ],
      [
        "Thử nạp (kỹ thuật)",
        "Chỉ dùng trên máy chủ test: tạo đơn thử và giả lập ngân hàng báo tiền.",
      ],
    ],
    note: "Giao dịch thử vẫn gửi Pet Coin thật và cộng vào tổng nạp — không dùng trên máy chủ có người chơi thật.",
  },
  shop: {
    intro:
      "Giá và hàng bán ở mọi cửa hàng trong game. Mỗi tab là một cửa hàng; trả bằng loại tiền ghi ở đầu bảng.",
    items: [
      [
        "Cửa hàng NPC",
        "Giá, số lượng mỗi lần mua, lượt mua mỗi ngày. Món không có nút Sửa là hàng cố định trong code.",
      ],
      [
        "Shop đấu trường / sinh tử",
        "Trả bằng điểm đấu trường / điểm lôi đài. Đầu shop là ô mảnh bốc ngẫu nhiên riêng từng người (tự bốc lại lúc 0h), sau đó là hàng cố định có giới hạn lượt.",
      ],
      ["Shop Pet Coin", "Hàng bán bằng tiền nạp (1 Pet Coin ≈ 100đ) và thẻ tháng."],
      ["Đổi Pet Coin ra vàng", "Các gói đổi, kèm tỉ giá để so; vàng nạp thẻ đang chờ cộng."],
      ["VIP", "Ngưỡng nạp từng bậc, quà lên cấp, quà tuần, gói VIP, shop ưu đãi."],
    ],
    note: "Mọi lần lưu đều hỏi lại và hiện cũ → mới; con số đổi từ 2 lần trở lên được cảnh báo đỏ.",
  },
  arena: {
    intro: "Thưởng hạng Đấu trường thần thú theo ngày và theo mùa.",
    items: [
      [
        "Giờ chốt",
        "Mỗi ngày đúng giờ này server lấy bảng hạng hiện tại (boss bảng hạng chiếm chỗ như trong game) và gửi thưởng ngày vào thư. Không khoá trận nào, trận xong sau giờ chốt tính cho hôm sau.",
      ],
      [
        "Mùa",
        "Mùa kết thúc đúng giờ chốt của ngày cuối: lần chốt đó gửi cả thưởng ngày lẫn thưởng mùa từ cùng một bảng hạng, rồi cúp mọi người được kéo về gần 1000 (1000 + (cúp − 1000) / 2). Điểm đấu trường không bị reset.",
      ],
      [
        "Mốc thưởng",
        "Mỗi mốc là một khoảng hạng; hạng đến = 0 nghĩa là từ hạng bắt đầu trở xuống hết. Các mốc cùng loại không được trùng nhau. Quà đã chốt được lưu lại nên sửa mốc không đổi quà của lần chốt trước.",
      ],
      [
        "Lịch sử chốt",
        "Mỗi lần chốt: số người có hạng, số người nhận, số thư đã gửi và đã nhận. Thư chưa gửi được (lỗi DB...) server tự gửi lại; bấm Gửi lại để thử ngay.",
      ],
      [
        "Phát thử thưởng",
        "Chốt ngay thưởng ngày hoặc mùa theo bảng hạng hiện tại cho vài người chọn theo tên (phát cho tất cả phải gõ xác nhận), thư có tiêu đề [Thử]. Không ảnh hưởng lần chốt thật. Quà là quà thật.",
      ],
    ],
    note: "Sửa mốc thưởng và phát thử tạo được quà cho người chơi nên cần quyền Sửa đấu trường.",
  },
  top: {
    intro: "Xem các bảng xếp hạng trong game.",
    items: [
      [
        "Các tab bảng xếp hạng",
        "Đúng nội dung người chơi thấy trong game, máy chủ tự làm mới mỗi 15 phút.",
      ],
      ["Làm mới ngay", "Tính lại bảng đang xem ngay lập tức."],
      ["PvP theo mùa", "Điểm Elo, số trận thắng/thua mùa hiện tại và các trận PvP gần đây."],
    ],
  },
  "arena-event": {
    intro:
      "Theo dõi và điều khiển lôi đài báo danh (NPC Đấu trường), dùng để test không cần chờ tới giờ.",
    items: [
      [
        "Trạng thái",
        "Đang báo danh / thi đấu, đồng hồ hết giờ báo danh, vòng hiện tại và lúc ghép vòng sau, lịch tự mở, các thông số luật.",
      ],
      [
        "Tự mở theo lịch",
        "Tắt để máy chủ không tự mở phiên theo giờ (phiên đang chạy vẫn chạy). Khởi động lại máy chủ thì bật lại.",
      ],
      [
        "Mở báo danh ngay",
        "Mở một phiên ngay với thời gian báo danh (30 giây - 15 phút) và thời gian trận (1 - 10 phút) tuỳ chọn để test.",
      ],
      ["Bắt đầu thi đấu", "Hết giờ báo danh ngay; ai không ở phòng chờ bị loại."],
      [
        "Kết thúc vòng",
        "Các trận đang đánh chốt như hết giờ (nhiều % máu hơn thắng), bỏ thời gian chờ còn lại; vòng sau ghép khi mọi người đã về phòng chờ.",
      ],
      ["Dừng lôi đài", "Huỷ trận đang đánh, gửi tổng kết, có thể hoàn phí cho người đang online."],
      ["Loại", "Loại một người khỏi lôi đài, không hoàn phí."],
      [
        "Mùa lôi đài",
        "Mỗi mùa 14 ngày, kết thúc 23:30 Chủ nhật. Chọn mùa để xem BXH: mùa chưa chốt hiện thưởng dự kiến, mùa đã chốt hiện quà và trạng thái thư của từng người.",
      ],
      [
        "Điều kiện thưởng",
        "Số trận tối thiểu để nhận thưởng hạng (người thiếu trận không đẩy người sau lên) và bật / tắt tự chốt thưởng khi hết mùa.",
      ],
      [
        "Mốc thưởng mùa",
        "Thưởng hạng theo khoảng hạng, mốc tham gia theo điểm mùa tối thiểu; cả hai gộp vào một thư. Danh hiệu có hạn tự hết đúng lúc kết thúc mùa sau.",
      ],
    ],
    note: "Người báo danh trong phiên test vẫn mất phí và nhận điểm lôi đài, điểm mùa thật.",
  },
  tower: {
    intro:
      "Tháp thử thách (NPC Đấu trường, lựa chọn 10): Bình thường 100 tầng, Khó 100 tầng, Địa ngục 10 tầng toàn boss. Chơi một mình, vào miễn phí, tiến độ reset 0h ngày 1 hằng tháng. Luật đầy đủ: docs/gameplay/12-thap-thu-thach.md.",
    items: [
      [
        "Mở / đóng",
        "Tạm đóng thì không ai vào được tháp; người đang trong tháp vẫn đánh tiếp tầng hiện tại.",
      ],
      [
        "Tháng",
        "Chọn tháng để xem BXH chung: độ khó cao nhất đã vào, rồi tầng cao nhất ở độ khó đó, rồi tổng thời gian qua tầng cả tháng (ngắn hơn đứng trên). Tháng chưa chốt xếp trực tiếp từ tiến độ; tháng đã chốt hiện top đã lưu và quà đã gửi.",
      ],
      [
        "Các tầng",
        "Loại tầng, số quái, cấp quái, hệ số máu / chỉ số (quái thường và tinh anh / boss tách riêng), nguyên mẫu, hình và tên boss, thời gian và quà vượt tầng lần đầu trong tháng.",
      ],
      [
        "Quà top tháng",
        "Gửi thư cho top BXH chung lúc chốt tháng. Mỗi mốc có độ khó tối thiểu: người trong khoảng hạng phải đã vào độ khó đó mới nhận; khớp nhiều mốc thì nhận mốc khó nhất. Danh hiệu có hạn tự hết cuối tháng kế tiếp.",
      ],
      [
        "Tiến độ người chơi",
        "Xem tầng cao nhất tháng này và 30 lượt gần nhất; sửa tầng (0 = xoá) để test, không gửi quà các tầng bị bỏ qua.",
      ],
      ["Chốt tháng", "Server tự chốt mỗi phút sau khi sang tháng; nút này chốt ngay."],
    ],
    note: "Sửa tầng áp dụng từ lần vào tầng sau. Quà đã gửi không đổi theo.",
  },
  worldBoss: {
    intro:
      "Boss thế giới ở Vực Hỗn Mang (map 37): ra theo giờ cố định mỗi ngày, cả server cùng đánh, xếp hạng theo sát thương rồi gửi thưởng qua thư.",
    items: [
      [
        "Đang diễn ra",
        "Boss nào đang đứng, còn bao lâu, bảng xếp hạng cá nhân và bang. Gọi boss ngoài lịch (bù lượt) hoặc kết thúc sớm và chốt thưởng ngay.",
      ],
      ["Lịch & boss", "Giờ boss ra mỗi ngày, boss nào ra vào thứ mấy, chỉ số của từng boss."],
      [
        "Thưởng & shop",
        "Quà theo hạng cá nhân, linh thạch theo hạng bang, hàng bán ở shop Hỗn Mang.",
      ],
      [
        "Lịch sử & tra cứu",
        "Các lượt đã qua (bấm để xem bảng xếp hạng lúc chốt) và tra một người chơi đã đánh những lượt nào.",
      ],
      [
        "Cấu hình (kỹ thuật)",
        "Độ khó và điều kiện nhận thưởng. Máy chủ kiểm cả bộ trước khi lưu; sai một ô thì không lưu gì.",
      ],
    ],
    note: "Sửa boss / thưởng không đổi lượt đang chạy và quà đã gửi; lượt sau mới dùng bản mới.",
  },
  "event-seasons": {
    intro:
      "Tạo và quản lý các đợt sự kiện (mùa): có giờ chạy, mốc quà, bảng xếp hạng. Máy chủ tự bật, tắt và gửi thưởng đúng giờ, không cần khởi động lại.",
    items: [
      [
        "Tạo mùa",
        "Chọn loại sự kiện có sẵn (tích nạp, bánh Tết, diều…), đặt tên, giờ bắt đầu và bấm nhanh số ngày chạy. Ô +% đổi vàng bật khuyến mãi đổi Pet Coin ra vàng trong mùa.",
      ],
      [
        "Trạng thái",
        "Chờ → Đang chạy → Đã hết giờ (khoảng 2 phút sau máy chủ chốt) → Đã chốt (đã gửi thưởng). Rê chuột lên trạng thái để xem giải thích.",
      ],
      [
        "Mốc quà",
        "Thưởng hạng và mốc toàn server gửi bằng thư lúc chốt. Mốc điểm người chơi tự nhận ở NPC.",
      ],
      ["Bảng điểm", "Xem ai đang dẫn đầu; bấm tên để mở trang người chơi."],
      [
        "Chép sang năm sau",
        "Tạo mùa mới giống mùa này vào cùng ngày năm sau. Mốc quà lấy theo mặc định — nhớ kiểm tra lại.",
      ],
      ["Huỷ mùa", "Dừng mùa, không chốt thưởng và không mở lại được."],
      [
        "Tự lặp lại",
        "Tự tạo mùa mỗi ngày / tuần / tháng. Mùa kỳ sau được tạo sẵn trước một kỳ để kịp sửa mốc quà.",
      ],
      ["Sự kiện nạp", "Quà nạp lần đầu và thống kê Pet Coin nạp theo mùa. Cần quyền riêng."],
    ],
    note: "Mùa đang chạy chỉ được rút ngắn giờ kết thúc, sửa chữ và hình; không đổi vật phẩm, công thức. Mùa đã chốt chỉ xem.",
  },
  events: {
    intro:
      "Xem các sự kiện có sẵn trong game đang chạy hay không. Trang chỉ để xem; tạo / sửa sự kiện ở trang Mùa sự kiện.",
    items: [
      ["Trạng thái", "Đang chạy, hoặc chưa tới giờ / đã hết. Sự kiện đang chạy luôn ở đầu bảng."],
      [
        "Đang chuẩn bị / Sắp kết thúc",
        "Đang chuẩn bị: máy chủ vừa bật, chưa nạp xong sự kiện (kéo dài thì báo kỹ thuật). Sắp kết thúc: sự kiện đã xong, máy chủ tự gỡ.",
      ],
      [
        "Tình hình hiện tại",
        "Ví dụ đấu trường đang mở đăng ký hay đang đấu, bao nhiêu người đã đăng ký.",
      ],
      ["Vật phẩm", "Các vật phẩm dùng được trong sự kiện đó."],
    ],
  },
  broadcast: {
    intro: "Gửi thông báo cho người chơi đang online (báo bảo trì, sự kiện, nhắc nhở).",
    items: [
      ["1. Gửi tới ai", "Toàn máy chủ, hoặc chỉ người đang ở một map (một khu hoặc mọi khu)."],
      [
        "2. Kiểu thông báo",
        "Chữ chạy (không làm phiền), Hộp thoại (che màn hình, phải bấm OK — chỉ dùng cho tin quan trọng), Thông báo nhỏ, Chat thế giới. Khung xem trước minh hoạ người chơi sẽ thấy gì.",
      ],
      ["3. Nội dung", "Gõ nội dung, hoặc bấm một mẫu có sẵn rồi sửa lại."],
      [
        "Banner tự động",
        "Chữ chạy tự lặp lại mỗi N phút tới lúc dừng (có nút chọn nhanh). Bấm Dừng để tắt sớm. Khởi động lại máy chủ thì phải thêm lại.",
      ],
    ],
    note: "Người đang offline không nhận được thông báo; muốn ai cũng thấy thì gửi thư ở trang Thư & quà.",
  },
  chat: {
    intro: "Chặn từ ngữ xấu trong chat và xem ai đang bị khoá chat.",
    items: [
      [
        "Thử một câu chat",
        "Gõ một câu để xem người chơi sẽ thấy ra sao (từ bị chặn hiện thành ***).",
      ],
      [
        "Thêm từ cấm",
        'Gõ từ rồi bấm Thêm (nhiều từ cách nhau bằng dấu phẩy). Nên để tick Thêm cả bản không dấu, vì chặn "địt" không tự chặn "dit".',
      ],
      ["Bỏ từ", "Tìm từ trong ô tìm, bấm dấu ✕ trên từ đó."],
      [
        "Lưu thay đổi",
        "Thêm / bỏ chỉ là nháp cho tới khi bấm Lưu thay đổi; khung vàng liệt kê đúng những từ sẽ thêm / bỏ. Lưu là áp dụng ngay.",
      ],
      ["Nâng cao", "Sửa cả danh sách dạng chữ, hoặc thêm bộ khoảng 600 từ cấm có sẵn."],
      [
        "Đang bị khoá chat",
        "Ai bị khoá, còn bao lâu, lý do, ai khoá; Gỡ khoá để cho chat lại ngay. Muốn khoá chat ai thì mở người đó ở trang Người chơi.",
      ],
    ],
  },
  giftcodes: {
    intro: "Tạo mã quà để người chơi gõ trong game và nhận quà (phát cho sự kiện, KOL, đền bù...).",
    items: [
      [
        "Tạo mã",
        "Đặt mã người chơi sẽ gõ, cho bao nhiêu người dùng, dùng được tới ngày nào (có nút chọn nhanh 7 / 30 / 90 ngày) và quà. Khung Kiểm tra lại cho thấy đúng thứ sẽ tạo.",
      ],
      [
        "Tạo nhiều mã",
        "Sinh nhiều mã ngẫu nhiên cùng một gói quà, mỗi mã cho 1 người (hoặc nhiều hơn). Tạo xong sao chép hoặc tải file .txt để gửi đi.",
      ],
      ["Mỗi người 1 lần", "Một tài khoản chỉ dùng mỗi mã một lần; mã bang thì mỗi bang một lần."],
      ["Ai đã dùng", "Danh sách nhân vật (hoặc bang) đã nhập mã, bấm tên để mở trang người chơi."],
      [
        "Sửa / Xoá",
        "Sửa để đổi quà, số lượt, hạn. Muốn dừng mã thì nên Sửa hạn về hôm nay thay vì xoá, để vẫn tra được ai đã dùng.",
      ],
    ],
  },
  balance: {
    intro: "Chỉnh các thông số cân bằng game mà không cần sửa code.",
    items: [
      [
        "Tham số",
        "Các con số như tỉ lệ, giá, giới hạn... Tham số đã khác mặc định có nút khôi phục để đưa về mặc định.",
      ],
      ["Bảng theo cấp", "Các bảng số theo từng cấp (ví dụ tỉ lệ cường hoá theo cấp)."],
    ],
    note: "Thay đổi áp dụng ngay cho mọi người chơi, hãy thử trên máy chủ test trước.",
  },
  rates: {
    intro: "Chỉnh tỉ lệ rơi đồ, quà và quái.",
    items: [
      ["Rơi đồ", "Tỉ lệ và số lượng rơi từng món khi đánh quái ở mỗi map, theo khoảng cấp."],
      ["Quà Tiên Nữ", "Bảng quà đổi bằng ngọc, thóc, vàng và tỉ lệ ra từng món."],
      ["Quái theo map", "Loại quái, cấp và số lượng ở từng map; thêm, sửa, xoá quái."],
      ["Quái theo cấp", "Chỉ số và phần thưởng của quái theo cấp."],
      ["Pet", "Điểm tiềm năng pet nhận mỗi lần lên cấp và điểm dung hợp của từng loại pet."],
    ],
    note: "Thay đổi áp dụng ngay, lưu luôn vào DB.",
  },
  "pet-evolve": {
    intro: "Quản lý tiến hoá pet ở NPC Tiên Nữ: pet chính + pet ảo ảnh = pet tiến hoá.",
    items: [
      [
        "Phí & điều kiện",
        "Phí trả bằng vàng hoặc ngọc (2 nút ở màn tiến hoá) và cấp tối thiểu của pet chính / pet ảo ảnh.",
      ],
      [
        "Điểm tiềm năng",
        "Mỗi lần lên cấp, pet tiến hoá nhận: sàn + mỗi sao × tổng sao của 2 pet (tính tối đa số sao đặt). Pet thiên đình và hạ giới có mức riêng.",
      ],
      [
        "Bảng tiến hoá",
        "Mỗi dòng là một công thức. Mỗi pet chính chỉ có một dòng; người chơi chỉ chọn được pet ảo ảnh đúng với pet chính.",
      ],
      [
        "Lưu ý",
        "Cột Lưu ý báo dòng trỏ tới pet không tồn tại, pet ảo ảnh chưa có mảnh ghép, hoặc pet chính lại là dạng tiến hoá của dòng khác.",
      ],
    ],
    note: "Sửa xong áp dụng ngay cho lần tiến hoá kế, không cần khởi động lại. Pet người chơi đã tiến hoá không bị đổi.",
  },
  auto: {
    intro: "Quản lý auto đánh quái: tốc độ trận khi auto và xem ai đang treo auto.",
    items: [
      [
        "Tốc độ trận khi auto",
        "Trận đánh quái thường và boss thần chết của map (khu thường, bản Unity) nhanh gấp bấy nhiêu khi người chơi bật auto. 150% = nhanh gấp 1,5. Đặt 100% để tắt. Đánh tay, boss khác, tháp, lôi đài giữ nhịp thường.",
      ],
      [
        "VIP tối thiểu",
        "Chỉ người chơi từ bậc VIP này trở lên mới được đánh nhanh. 0 = mọi người, -1 = không ai.",
      ],
      [
        "Đang treo auto",
        "Người chơi đang bật auto và thống kê phiên hiện tại: quái / boss đã hạ, EXP, ngọc, rơi đồ, số trận thua. Cột Đánh nhanh cho biết người đó có được tăng tốc không và tốc độ trận đang đánh.",
      ],
    ],
    note: "Lưu xong áp dụng cho trận mới, trận đang đánh giữ tốc độ lúc vào trận. Hai tham số này cũng nằm trong trang Cân bằng (nhóm Auto đánh quái).",
  },
  "lucky-wheel": {
    intro: "Chỉnh vòng quay may mắn: số lượt quay miễn phí, quà và tỉ lệ trúng của 18 ô.",
    items: [
      [
        "Lượt quay",
        "Mỗi ngày ai cũng có số lượt chung, mỗi cấp VIP được thêm lượt. Không bán lượt, hết lượt là phải chờ qua 0h.",
      ],
      [
        "Chắc chắn trúng ô góc sau",
        "Quay đủ số lượt này liên tiếp mà chưa trúng ô góc thì lượt kế chắc chắn trúng ô góc. Đặt 0 để tắt.",
      ],
      [
        "18 ô quà",
        "Xếp đúng như trong game: 4 ô góc (★) là quà lớn. Bấm vào ô để đổi quà và trọng số — gõ trọng số sẽ thấy ngay tỉ lệ %. Trọng số 0 là không bao giờ trúng.",
      ],
      [
        "Thống kê",
        "Số lượt quay hôm nay, 7 ngày gần nhất và số lần trúng từng ô để so với tỉ lệ đặt.",
      ],
    ],
    note: "Sửa ô chỉ là nháp (khung vàng liệt kê thay đổi). Bấm Lưu sẽ hỏi lại rồi áp dụng ngay cho lượt quay kế của mọi người.",
  },
  checkin: {
    intro:
      "Quản lý điểm danh tháng, chia 4 tab: Tháng này / Tháng sau (bảng quà từng ngày và quà mốc), Kho quà & cài đặt (giá bù, kho quà random), Tra người chơi.",
    items: [
      [
        "Luật trong game",
        'Ô "Ngày N" chỉ nhận miễn phí trong đúng ngày N (giờ máy chủ). Ngày đã qua chưa nhận thì bấm để bù bằng vàng. Đủ 7 / 14 / 21 / 28 ngày đã nhận trong tháng (tính cả ngày bù) tự nhận quà mốc. Lần đầu vào game trong ngày màn tự bật.',
      ],
      [
        "Kho quà",
        "Mỗi tháng random bảng quà một lần từ kho: ngày chia hết cho 7 và ngày cuối tháng lấy quà Hiếm, các ngày khác lấy quà Thường; mốc lấy 2 / 3 / 4 / 5 quà Hiếm khác nhau. % là tỉ lệ trong cùng độ hiếm. Sửa kho không đổi bảng đã random, muốn áp dụng thì bấm Random lại.",
      ],
      [
        "Bảng quà tháng",
        "Bấm vào ô ngày hoặc thẻ mốc để đổi quà rồi bấm Lưu của bảng (sẽ hỏi lại, cảnh báo nếu đổi ngày đã có người nhận). Tháng sau có thể sinh trước để xem và sửa; không sinh thì sang tháng tự random lúc có người mở màn.",
      ],
      [
        "Tra người chơi",
        "Gõ tên nhân vật hoặc tên tài khoản để xem khách đã nhận những ngày nào: xanh là đúng ngày, cam là ngày bù (rê chuột để xem vàng và giờ nhận).",
      ],
    ],
    note: "Đã có người nhận thì hạn chế đổi quà những ngày đã qua: màn sẽ hiện quà mới, khác quà người chơi đã được.",
  },
  collection: {
    intro:
      "Quản lý bộ sưu tập, chia 4 tab: Danh sách ô (tên, ảnh, nguồn, ẩn / hiện), Mốc quà, Tra người chơi (xem và kích hoạt hộ), Tỉ lệ & trần (kỹ thuật).",
    items: [
      [
        "Luật trong game",
        "Người chơi tự bấm Kích hoạt khi đang có món đó (túi, kho, đồ đang mặc, pet, hình xăm trên pet); món đồ giữ nguyên. Đồ treo ki-ốt, trong thư, hết hạn, pet dùng thử không tính. Bộ trang bị kích hoạt từng mảnh, đủ mảnh mới tính một ô. Ô pet ghi sao cao nhất.",
      ],
      [
        "Ô ẩn",
        "Ô ẩn không hiện, không kích hoạt được, không cộng chỉ số, không tính mốc. Dùng cho đồ không còn nguồn, pet chưa có ảnh. Bỏ ẩn là hiện ngay.",
      ],
      [
        "Mốc quà",
        'Mốc theo số ô của từng trang, mốc sao (trang Pet) và mốc tổng. Số ô cần 0 = "đủ trang". Mỗi tài khoản nhận mỗi mốc một lần. Lưu sẽ hỏi lại, liệt kê mốc thêm / sửa / bỏ.',
      ],
      [
        "Tra người chơi",
        "Gõ tên nhân vật hoặc tên tài khoản. Kích hoạt hộ: chọn ô bằng cách gõ tên ô, ghi lý do — chỉ dùng khi khách có bằng chứng.",
      ],
      [
        "Tỉ lệ & trần (kỹ thuật)",
        "Mỗi ô cộng % chỉ số gốc của món cho mọi pet, tổng cả bộ không vượt trần. Ảnh hưởng sức mạnh mọi người chơi — chỉ sửa khi kỹ thuật yêu cầu.",
      ],
      [
        "Sinh ô cho món mới",
        "Khi game có thêm pet / vật phẩm / hình xăm mới thì bấm để có ô mới. Ô đã có giữ nguyên.",
      ],
    ],
    note: "Kích hoạt hộ chỉ dùng khi có bằng chứng; mọi thao tác sửa đều ghi lịch sử admin.",
  },
  simulator: {
    intro:
      "Thử ráp pet, trang bị, ngọc, hình xăm... để xem chỉ số cuối cùng. Không đụng tới dữ liệu thật.",
    items: [
      ["Con pet", "Chọn pet, cấp, sao và chia điểm tiềm năng."],
      ["Trang bị, cánh & cải trang", "Chọn đồ, cấp cường hoá, dung hợp, khảm ngọc cho từng ô."],
      ["Hình xăm, danh hiệu, bị động", "Thêm các nguồn chỉ số không nằm trên ô trang bị."],
      ["Chỉ số", "Máy chủ tính bằng đúng công thức trong game, dùng để cân bằng đồ."],
    ],
  },
  templates: {
    intro: "Sửa dữ liệu gốc (mẫu) của vật phẩm, pet, danh hiệu, hình xăm; xem map.",
    items: [
      [
        "Vật phẩm",
        "Tên, mô tả, icon, giá, giao dịch được hay không, hạn dùng, yêu cầu chỉ số, chỉ số và dòng hiệu ứng.",
      ],
      ["Pet", "Tên, icon, chỉ số gốc sức / nhanh / trí của pet."],
      ["Danh hiệu, Hình xăm", "Tên, icon và chỉ số cộng thêm."],
      ["Map", "Danh sách map, boss và số khu của từng map."],
      ["Tải icon", "Đưa ảnh icon mới lên máy chủ để gắn cho vật phẩm."],
    ],
    note: "Sửa mẫu áp dụng ngay cho mọi món cùng loại, kể cả đồ người chơi đang có.",
  },
  history: {
    intro: "Tra cứu nhật ký của người chơi và admin.",
    items: [
      [
        "Hoạt động",
        "Mọi thao tác được ghi lại (mua bán, nhận quà, thao tác của admin...). Lọc theo tên nhân vật, từ khoá, khoảng thời gian, hoặc chỉ thao tác web admin.",
      ],
      [
        "Đăng nhập",
        "Lần đăng nhập game và web: thời gian, IP, thành công hay sai mật khẩu. Lọc theo tài khoản, IP, hoặc chỉ lần thất bại.",
      ],
    ],
  },
  errors: {
    intro:
      "Mọi cảnh báo / lỗi GServer ghi ra được gộp theo nhóm: cùng loại lỗi ở cùng một hàm là một dòng, kèm số lần và người chơi gặp lỗi.",
    items: [
      [
        "Đọc bảng",
        "Mỗi dòng là một nhóm lỗi. Bấm vào dòng để xem stack trace, danh sách người chơi gặp lỗi (bấm tên để mở trang người chơi) và các lần xảy ra gần nhất.",
      ],
      [
        "Người chơi",
        "Lỗi xảy ra khi đang xử lý thao tác của người chơi thì ghi kèm người đó. Lỗi ở luồng nền (map, boss, lưu dữ liệu) không có người chơi.",
      ],
      [
        "Đã xử lý",
        'Đánh dấu sau khi đã sửa và deploy. Nếu lỗi xảy ra lại, nhóm tự mở lại với nhãn "Tái phát": bản sửa chưa ăn.',
      ],
      [
        "Bỏ qua",
        "Cho cảnh báo đã biết, không cần sửa. Nhóm bỏ qua vẫn đếm số lần nhưng không tự mở lại.",
      ],
      [
        "Lưu trữ",
        "Nhóm lỗi giữ mãi; chi tiết từng lần (thời gian, người chơi) giữ 14 ngày. Lỗi dồn dập chỉ lưu tối đa 20 dòng chi tiết mỗi 5 giây, số lần vẫn đếm đủ.",
      ],
    ],
  },
  "server-settings": {
    intro: "Cấu hình máy chủ, có hiệu lực ngay không cần khởi động lại.",
    items: [
      [
        "Đăng nhập game",
        "Chỉ cho admin vào game (đang test), hoặc chặn mọi lượt đăng nhập kèm câu thông báo. Không ảnh hưởng đăng nhập web.",
      ],
      [
        "Phiên bản client",
        "Client cũ hơn bản tối thiểu bị chặn và được nhắc tải bản mới theo đường link.",
      ],
      ["Hệ số exp / ngọc", "Nhân exp và ngọc khi đánh quái (100% là bình thường, 200% là x2)."],
      ["Lưu tất cả ngay", "Ghi ngay dữ liệu người chơi online, bang hội và chợ xuống DB."],
      ["Sao lưu DB", "Tạo bản backup DB ngay; danh sách các bản đã có nằm bên dưới."],
      [
        "IP được vào web admin",
        "Chỉ những IP trong danh sách mở được trang này. Danh sách luôn phải còn IP máy bạn đang dùng.",
      ],
    ],
  },
  permissions: {
    intro: "Cho tài khoản khác vào web admin với một phần quyền.",
    items: [
      ["Cấp quyền", "Chọn tài khoản và tích các quyền; quyền xem đi kèm được tự thêm."],
      ["Tạo tài khoản mới rồi cấp quyền", "Tạo luôn tài khoản cho người được giao quản lý."],
      ["Tài khoản được phân quyền", "Đổi hoặc gỡ quyền; có hiệu lực trong tối đa 1 phút."],
    ],
    note: "Quyền đánh dấu nguy hiểm tạo được tài sản hoặc làm gián đoạn máy chủ, chỉ cấp cho người tin tưởng.",
  },
};

export default PAGE_GUIDES;
